import React, {useState, useEffect} from "react";
import {UsersService} from "../services/UsersService";
import {useParams} from "react-router-dom";
import {toHumanDateTime} from "../services/Date";
import Loader from "../components/Loader";
import {Calendar} from 'primereact/calendar'

export default function UserEditLearning() {

    let props = useParams()

    const [attendances, setAttendances] = useState(false);
    const [dates, setDates] = useState([])



    useEffect(() => {
        let cleanupFunction = false;
        const fetchData = async () => {
            try {
                UsersService.GetHrAttendances(props.userId).then((response) => {

                    setAttendances(response.items)
                    let d = []
                    if(response.items.length > 0){
                        response.items.map((el) => {
                          d.push(new Date(el.planing.start * 1000))
                        })
                    }
                    setDates(d)
                })
            } catch (e) {

            }
        }
        fetchData();

        // функция очистки useEffect
        return () => cleanupFunction = true;
    }, [])


    return (
        <div className={'card'}>
            <div className="card-body">
                <h3 className={'m-b-30'}>Записи на обучение</h3>
                {attendances ?
                    <>

                    <table className={'table table-bordernone'}>
                        <thead>
                        <tr>
                            <th>Программа</th>
                            <th>Тип обучения</th>
                            <th>Дата проведения</th>
                            <th>Статус</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {attendances.map((el) => {
                            if(!el.planing) return;
                            let d = new Date(el.planing.start * 1000)
                            return (
                                <tr>
                                    <td>{el.planing.course.name}</td>
                                    <td>{el.planing.course.type}</td>
                                    <td>{toHumanDateTime(el.planing.start)}</td>
                                    <td>{el.statusText}</td>
                                    <td>
                                        {el.status === 0 ?
                                            <div className="table__actions">
                                                <div className="btn-group-sm">
                                                    <button className={'btn btn-default'} title={'Отменить запись'}>
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            : ''}
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                        <div className={'m-t-30'}></div>
                        <Calendar inline value={dates} selectionMode="multiple"/>
                    </>
                    : <Loader/>}
            </div>
        </div>
    )

}